import { render, staticRenderFns } from "./xindian.vue?vue&type=template&id=466bbdac&scoped=true"
import script from "./xindian.vue?vue&type=script&lang=ts"
export * from "./xindian.vue?vue&type=script&lang=ts"
import style0 from "./xindian.vue?vue&type=style&index=0&id=466bbdac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466bbdac",
  null
  
)

export default component.exports